import { render, staticRenderFns } from "./tasksContainer.vue?vue&type=template&id=2f3c6697&scoped=true"
import script from "./tasksContainer.vue?vue&type=script&lang=js"
export * from "./tasksContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3c6697",
  null
  
)

export default component.exports